export class NetworkManager {
    ws = null;
    serverUrl;
    // 我的 ID
    sessionId = '';
    // 回调
    onWorldSnapshot = null;
    onPlayerJoin = null;
    onPlayerLeave = null;
    onStateUpdate = null;
    onDamage = null;
    onSkillCast = null;
    onPlayerKilled = null;
    onMonsterKilled = null;
    onMonsterSpawn = null;
    onChat = null;
    constructor() {
        const isDev = import.meta.env?.DEV;
        this.serverUrl = isDev
            ? 'ws://127.0.0.1:3001'
            : 'wss://jianghu-legends-server.onrender.com';
    }
    joinWorld(name, faction) {
        return new Promise((resolve, reject) => {
            console.log('[Network] 连接服务器:', this.serverUrl);
            this.ws = new WebSocket(this.serverUrl);
            this.ws.onopen = () => {
                console.log('[Network] WebSocket 已连接');
            };
            this.ws.onmessage = (event) => {
                const msg = JSON.parse(event.data);
                this.handleMessage(msg, name, faction, resolve);
            };
            this.ws.onerror = (err) => {
                console.error('[Network] 连接错误:', err);
                reject(err);
            };
            this.ws.onclose = () => {
                console.log('[Network] 连接关闭');
            };
            // 超时
            setTimeout(() => reject(new Error('连接超时')), 5000);
        });
    }
    handleMessage(msg, name, faction, resolveJoin) {
        switch (msg.type) {
            case 'connected':
                // 收到服务器分配的 ID，发送 join
                this.sessionId = msg.id;
                console.log('[Network] 收到ID:', this.sessionId, '发送join...');
                this.send({ type: 'join', name, faction });
                break;
            case 'world_snapshot':
                console.log('[Network] 收到世界快照:', msg.players?.length, '玩家,', msg.monsters?.length, '怪物');
                this.onWorldSnapshot?.(msg);
                resolveJoin?.();
                break;
            case 'player_join':
                this.onPlayerJoin?.(msg.player);
                break;
            case 'player_leave':
                this.onPlayerLeave?.(msg.id);
                break;
            case 'state_update':
                this.onStateUpdate?.(msg);
                break;
            case 'damage':
                this.onDamage?.(msg);
                break;
            case 'skill_cast':
                this.onSkillCast?.(msg);
                break;
            case 'player_killed':
                this.onPlayerKilled?.(msg);
                break;
            case 'monster_killed':
                this.onMonsterKilled?.(msg);
                break;
            case 'monster_spawn':
                this.onMonsterSpawn?.(msg);
                break;
            case 'chat':
                this.onChat?.(msg);
                break;
        }
    }
    send(data) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify(data));
        }
    }
    sendMove(msg) {
        this.send({ type: 'move', ...msg });
    }
    sendAttack(msg) {
        this.send({ type: 'attack', ...msg });
    }
    sendTogglePK() {
        this.send({ type: 'toggle_pk' });
    }
    sendChat(content) {
        this.send({ type: 'chat', content });
    }
    leave() {
        this.ws?.close();
    }
}
